import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { ContentLayout6 } from '@components/content/components/content-layout-6/model';
import { ResponsiveService } from '@services/responsive';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-content-layout-6',
  imports: [TitleComponent],
  templateUrl: './content-layout-6.component.html',
  styleUrl: './content-layout-6.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout6Component implements OnInit {
  readonly data = input.required<ContentLayout6>();
  breakpoints = inject(ResponsiveService).breakpoints;
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);

  ngOnInit(): void {
    const data = this.data();
    this.title.set({
      level: data.titleLevel ? data.titleLevel : 'H2',
      size: {
        mobile: 'H2',
        desktop: 'H2',
      },
      font: 'IVY_MODE',
      color: 'BLACK',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().title,
    });
    this.subtitle.set({
      level: 'SPAN',
      type: 'SLASH',
      size: {
        mobile: 'SPAN',
        desktop: 'SPAN',
      },
      color: 'GREY_LIGHT',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      weight: 500,
      text: this.data().subtitle,
    });
  }
}
